import React from 'react';
import styles from './PricingCard.module.scss';
import CTAButton from './CTAButton';
import FeatureItem from './FeatureItem';

const PricingCard = ({
  icon,
  title,
  subtitle,
  price,
  savings,
  features,
  featuresTitle,
  variant = 'default',
  comingSoon = false,
  onGetAccess
}) => {
  return (
    <div className={`${styles.card} ${styles[variant]} ${comingSoon ? styles.comingSoon : ''}`}>
      <div className={styles.header}>
        <div className={styles.iconWrapper}>
          {icon}
        </div>
        <div className={styles.titleGroup}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </div>

      <div className={styles.pricing}>
        <span className={styles.price}>${price}</span>
        <span className={styles.savings}>*Save ${savings}</span>
      </div>

      {comingSoon ? (
        <div className={styles.comingSoonBtn}>
          Coming Soon
        </div>
      ) : (
        <CTAButton onClick={onGetAccess} variant="dark" size="large">
          Get lifetime access
        </CTAButton>
      )}

      <div className={styles.divider} />

      <div className={styles.features}>
        <p className={styles.featuresTitle}>{featuresTitle}</p>
        <div className={styles.featuresList}>
          {features.map((feature, index) => (
            <FeatureItem key={index}>{feature}</FeatureItem>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingCard;
